import { AppColors } from "@/styles/colors";
import { Accordion, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface Props {
  title: string;
  value: string;
  content: ReactNode;
  variant?: string;
}

export const CustomAccordion = ({ title, content, value, variant }: Props) => {
  return (
    <Accordion.Item
      value={value}
      border="none"
      _open={{
        bgColor: variant === "subtle" ? "#E1E9E5" : "transparent",
      }}
      data-testid="accordion-main-item"
    >
      <Accordion.ItemTrigger paddingX="12px" cursor="pointer">
        <Text
          flex="1"
          color={AppColors.GRAY_TEXT}
          fontWeight={400}
          fontSize={{ base: "14px", md: "14px", "2xl": "20px" }}
          paddingY="10px"
        >
          {title}
        </Text>

        <Accordion.ItemIndicator />
      </Accordion.ItemTrigger>
      <Accordion.ItemContent paddingX="12px">
        <Accordion.ItemBody>{content}</Accordion.ItemBody>
      </Accordion.ItemContent>
    </Accordion.Item>
  );
};
